import {
  IonAccordion,
  IonAccordionGroup,
  IonCol,
  IonItem,
  IonLabel,
  IonRow,
  IonSearchbar,
  IonText,
} from "@ionic/react";
import { useEffect, useRef, useState } from "react";
import "../IonColor/color.css";
import "../generalCSS/stylesheet.css";
import "./Datasheets.css";

import { pdfjs } from "react-pdf";
import { makeGETRequest } from "../../request/rawRequest";
import { getCurrentTechnoOrDisconnect } from "../../variables/jobDictionnary";
import BasicPage from "../BasicPage/BasicPage";
import Viewer from "../Book/Viewer";
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

interface ContainerProps {}

export interface Datasheets {
  name: string;
  link: string;
}

const getExoParams = (value: string) => {
  if (value === "tp") return "tp";
  return "directed";
};

const Datasheets: React.FC<ContainerProps> = () => {
  const urlParams = new URLSearchParams(window.location.search);

  const [datasheets, setDatasheets] = useState<Datasheets[]>([]);

  const [datasheetsDisplay, setDatasheetsDisplay] = useState<Datasheets[]>([]);

  const [searchText, setSearchText] = useState<string>("");

  const accordionGroup = useRef<null | HTMLIonAccordionGroupElement>(null);
  const toggleAccordion = () => {
    if (!accordionGroup.current) {
      return;
    }
    const nativeEl = accordionGroup.current;

    nativeEl.value = undefined;
  };

  const [numPages, setNumPages] = useState(0);
  const ref = useRef<HTMLDivElement>(null);
  const [width, setWidth] = useState(0);
  let movement_timer: any = null;
  const RESET_TIMEOUT = 100;

  const init_dimensions = () => {
    if (ref.current) {
      setWidth(ref.current.offsetWidth);
    }
  };
  window.addEventListener("resize", () => {
    clearInterval(movement_timer);
    movement_timer = setTimeout(init_dimensions, RESET_TIMEOUT);
  });

  function onDocumentLoadSuccess({ numPages }: { numPages: number }) {
    setNumPages(numPages);
    init_dimensions();
  }

  useEffect(() => {
    if (searchText.length <= 0) {
      setDatasheetsDisplay(datasheets);
    } else {
      setDatasheetsDisplay(
        datasheets.filter((s) =>
          s.name.replaceAll(" ", "").includes(searchText.replaceAll(" ", ""))
        )
      );
    }
  }, [searchText, datasheets]);

  useEffect(() => {
    makeGETRequest(
      "/files/specific?pole=" +
        getCurrentTechnoOrDisconnect() +
        "&exercice=" +
        getExoParams(urlParams.get("type") ?? "")
    ).then((response) => {
      setDatasheets(response);
    });
  }, []);

  return (
    <BasicPage pathReturn title="Fiches techniques" width="10">
      <IonRow>
        <IonCol className="ion-justify-content-center">
          <IonSearchbar
            value={searchText}
            onIonChange={(e) => {
              setSearchText(e.detail.value!);
              toggleAccordion();
            }}
            animated
            placeholder="Recherche d'une fiche technique"
          ></IonSearchbar>
        </IonCol>
      </IonRow>
      <IonRow>
        <IonCol className="ion-justify-content-center">
          <IonAccordionGroup ref={accordionGroup} key={""}>
            {datasheetsDisplay.map((m, i) => {
              return (
                <IonAccordion
                  style={{ display: "flex", flexDirection: "column" }}
                  value={"datasheet" + i}
                  key={i}
                >
                  <IonItem slot="header">
                    <IonLabel>{m.name}</IonLabel>
                  </IonItem>
                  <div className="ion-padding" slot="content">
                    <div ref={ref} className="fullWidth margin">
                      <Viewer
                        fileURL={m.link}
                        setBookLoader={() => {}}
                        goToTop={false}
                      />
                    </div>
                  </div>
                </IonAccordion>
              );
            })}
          </IonAccordionGroup>
          {datasheetsDisplay.length === 0 ? (
            <IonText color="black">
              <h3>
                Il n'y a pas encore de fiches techniques{" "}
                {searchText.length > 0
                  ? 'sur ce thème : "' + searchText + '"'
                  : ""}
              </h3>
            </IonText>
          ) : (
            ""
          )}
        </IonCol>
      </IonRow>
      <IonRow>
        <IonItem color="transparent"></IonItem>
      </IonRow>
    </BasicPage>
  );
};

export default Datasheets;
